module.exports = __webpack_public_path__ + "img/avatar_ico3.b92df762.jpg";